
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaArrowRight, FaPlay } from 'react-icons/fa';
import './ODC.css';

import heroBg from '../../Assets/Services/ODC/Background.png';
// Using placeholders for now
import introImage from '../../Assets/Services/ODC/Ship (1).png';
import whyChooseImage from '../../Assets/Services/ODC/Truck (1).png';

const ODC = () => {

    // ScrollToTop component in App.js handles scrolling on route change

    const fadeInUp = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
    };

    return (
        <div className="odc-transport">

            {/* Hero Section */}
            <div className="odc-hero" style={{ backgroundImage: `url(${heroBg})` }}>
                <Container>
                    <motion.div
                        className="odc-hero-content"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h1>ODC & Heavy Cargo Transport</h1>
                        <p>Safe and engineered transportation of over-dimensional and heavy industrial cargo across India.</p>
                    </motion.div>
                </Container>
            </div>

            {/* Intro Section */}
            <section className="odc-intro">
                <Container>
                    <Row>
                        <Col md={12}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <img src={introImage} alt="ODC Service" className="img-fluid" />
                            </motion.div>
                        </Col>
                        <Col md={12} className="mt-4">
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>Engineered Heavy Logistics Solutions</h2>
                                <p>
                                    Janta Roadways specializes in transporting Over-Dimensional Cargo (ODC) and heavy industrial equipment across India. Our
                                    fleet includes hydraulic modular trailers, multi-axle low-bed carriers, and specialized heavy-duty transport systems designed
                                    to handle extreme weight and dimensions.
                                    <br />
                                    We support infrastructure, power, refinery, steel, cement, and large-scale project logistics with precision route planning, escort
                                    coordination, and regulatory compliance.
                                    <br />
                                    From factory dispatch to site delivery, every movement is executed with engineering precision and operational control.
                                </p>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Why Choose Section */}
            <section className="odc-why-choose">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>Why Choose Our ODC Transport</h2>
                                <span className="subtitle">Built for complexity. Delivered with precision.</span>

                                <ul className="why-choose-list">
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Hydraulic modular & multi-axle trailers</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Route survey & bridge clearance analysis</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Permit & escort coordination</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Engineering-based load securing</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Experienced heavy-haul operators</li>
                                </ul>
                            </motion.div>
                        </Col>
                        <Col md={6}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <img src={whyChooseImage} alt="ODC Trailer" className="why-choose-image shadow-sm" />
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Process Framework */}
            <section className="odc-process">
                <Container>
                    <Row className="align-items-center">
                        <Col md={7}>
                            <motion.div
                                className="video-placeholder shadow"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <div className="play-button">
                                    <FaPlay size={20} />
                                </div>
                            </motion.div>
                        </Col>
                        <Col md={5}>
                            <motion.div
                                className="process-content"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>Our Heavy Cargo Execution Process</h2>
                                <div className="process-steps">
                                    <div className="process-step">Technical Assessment</div>
                                    <div className="process-step">Route Survey & Planning</div>
                                    <div className="process-step">Permit & Escort Management</div>
                                    <div className="process-step">Secure Loading & Deployment</div>
                                    <div className="process-step">Execution & Monitoring</div>
                                </div>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default ODC;
